import OddsBtn, { useRedirectConfirmationModal } from "@/components/oddsBtn";
import TeamPlayerAvatar from "@/components/teamPlayerAvatar";
import { SPORTSBOOK_URL } from "@/constants/amplitude";
import { NFL } from "@/constants/sports";
import RedirectToSportsbook from "@/events/Modals/RedirectToSportsbookModal";
import { OddsSelection } from "@/graphql/gql/graphql";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import styles from "./playerProp.module.scss";

interface PlayerPropProps {
  underSelection: OddsSelection | null;
  overSelection: OddsSelection | null;
  isMobile: boolean;
}

function PlayerProp(props: PlayerPropProps) {
  const { overSelection, underSelection, isMobile } = props;
  const { eventName } = useHeadToHeadContext();
  const { onOddsClick, redirectToSportsbookProps } =
    useRedirectConfirmationModal(NFL, eventName, "featured_player_props");
  if (overSelection == null || underSelection == null) {
    return (
      <div className={styles.row}>
        <div className={styles.left}>
          {!isMobile && (
            <TeamPlayerAvatar
              primaryImgName={"jerseyLogoAltText"}
              primaryImgUrl={null}
              primaryImgSize={60}
              secondaryImgName={"teamAltText"}
              secondaryImgUrl={null}
              secondaryImgSize={28}
            />
          )}
          <div className={styles.playerInfo}>
            <div className={styles.name}>Player</div>
            <div className={styles.playerDesc}>
              <span>QB • 100 Average Yards</span>
            </div>
          </div>
        </div>

        <div className={styles.oddsBtns}>
          <OddsBtn
            classButton={styles.btn}
            isSuspended
            odds={0}
            onClick={() => null}
          />
          <OddsBtn
            classButton={styles.btn}
            isSuspended
            odds={0}
            onClick={() => null}
          />
        </div>
      </div>
    );
  }

  const {
    odds: overOdds,
    formattedHandicap: overHandicap,
    player,
    playerStat,
  } = overSelection;
  const { odds: underOdds, formattedHandicap: underHandicap } = underSelection;

  const playerName = player?.name ?? "";
  const jerseyLogoAltText = playerName
    ? `${playerName} Jersey Logo`
    : "Jersey Logo";
  const jerseyUrl = player?.teamInfo?.teamJersey?.svg;
  const teamName = player?.teamInfo?.shortName;
  const teamAltText = `${teamName ?? "Team"} Logo`;
  const teamLogoUrl = player?.teamInfo?.logo?.svg;
  const canRenderPosition = player?.position != null;

  const { value, units } = playerStat ?? {};
  const canRenderStat = value != null && units != null;
  const avgStat = `${value?.toLocaleString(undefined, { maximumFractionDigits: 0 })} Average ${units}`;

  return (
    <div className={styles.row}>
      <div className={styles.left}>
        {!isMobile && (
          <TeamPlayerAvatar
            primaryImgName={jerseyLogoAltText}
            primaryImgUrl={jerseyUrl}
            primaryImgSize={60}
            secondaryImgName={teamAltText}
            secondaryImgUrl={teamLogoUrl}
            secondaryImgSize={28}
          />
        )}
        <div className={styles.playerInfo}>
          <div className={styles.name}>{playerName}</div>
          <div className={styles.playerDesc}>
            <span>
              {canRenderPosition && player.position}
              {canRenderPosition && canRenderStat && " • "}
              {canRenderStat && avgStat}
            </span>
          </div>
        </div>
      </div>

      {overOdds != null && underOdds != null && (
        <div className={styles.oddsBtns}>
          <RedirectToSportsbook {...redirectToSportsbookProps} />
          <OddsBtn
            classButton={styles.btn}
            odds={overOdds}
            handicap={overHandicap}
            onClick={() => onOddsClick(overSelection.url ?? SPORTSBOOK_URL)}
          />
          <OddsBtn
            classButton={styles.btn}
            odds={underOdds}
            handicap={underHandicap}
            onClick={() => onOddsClick(underSelection.url ?? SPORTSBOOK_URL)}
          />
        </div>
      )}
    </div>
  );
}
export default PlayerProp;
